// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB7AutMyTj12aoO8xfY2t1uqQUll5HLTAo",
    authDomain: "polycrestke.firebaseapp.com",
    projectId: "polycrestke",
    storageBucket: "polycrestke.firebasestorage.app",
    messagingSenderId: "1069851365746",
    appId: "1:1069851365746:web:a4c13236571f926cb94deb",
    measurementId: "G-05BX4Q9DFC"
  };
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore();

export {app};
export {analytics}
export {db}